"use client";

import { ButtonProps } from "@/components/ui/button";
import { LoadingButton } from "@/components/ui/loading-button";
import { useFormStatus } from "react-dom";

export function AuthenticationEmailSubmitButton({
  children,
  ...props
}: ButtonProps) {
  const { pending } = useFormStatus();

  return (
    <LoadingButton
      type="submit"
      {...props}
      aria-disabled={pending}
      loading={pending}
    >
      {children}
    </LoadingButton>
  );
}
